import { render, staticRenderFns } from "./MenuInterface.vue?vue&type=template&id=223b1ed2&"
import script from "./MenuInterface.vue?vue&type=script&lang=js&"
export * from "./MenuInterface.vue?vue&type=script&lang=js&"
import style0 from "./MenuInterface.vue?vue&type=style&index=0&id=223b1ed2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports